/*
 * @author Tommy Brière
 * @copyright (c) 2015 Groupe PVP
 * @fileoverview Afficher les asset une à la suite des autre
 */
(function($g, createjs, $) {
    "use strict";
    //var OVERLAP = 250;
    var INTRO_DURATION = 9000;
    var ASSET_DELAY = 10000;
    var FADE_DURATION = 500;
    var END_DURATION = 5000;

    var Event = createjs.Event;
    var Shape = createjs.Shape;
    var Tween = createjs.Tween;
    var Ease = createjs.Ease;
    var EventDispatcher = createjs.EventDispatcher;
    var Bitmap = createjs.Bitmap;
    var Loader = $g.Loader;

    var Killable = $g.Killable;
    var Photo = $g.Photo;
    var Video = $g.Video;
    var tri = $g.try;
    var Introduction = $g.Introduction;
    var Conclusion = $g.Conclusion;
    var Message = $g.Message;

    var UNLOADED={};
    var LOADING={};
    var UNSTARTED={};
    var STARTING={};
    var PLAYING={toString: function() {
            return "PLAYING";
    }};
    var PAUSED={};
    var COMPLETED={};
  	var STATES={
      UNLOADED:UNLOADED,
      LOADING:LOADING,
      UNSTARTED:UNSTARTED,
      STARTING:STARTING,
      PLAYING:PLAYING,
      PAUSED:PAUSED,
      COMPLETED:COMPLETED
    };

    function Slideshow(server, imgLoader, stage, container, opt, baseUrl) {
        var me = this;
        Killable.call(me);
        var assets;
        var total;
        var fond;
        var transition;

        var slideIndex = 0;
        var slide;
        var duration;
        var position = 0;
        var loaded = 0;
        var loadedDuration = 0;
        var instances=[];
        var etat = UNLOADED;
        var defaultOpt = {
            loop: false
        };
        opt = $.extend({}, defaultOpt, opt);
        var nuageUrl = "";
        var data;
        var lang;
        var logoReady;
        var bmpLogo;
        var version = 0;
        var loadAhead = 4;
        var skipError = false;
        var loopCount = 1;
        var videoDirectDisplay = false;

        var ready = new EventDispatcher();

        Object.defineProperties(me, {
            index: {
                get: function() {
                    return slideIndex;
                }
            },
            total: {
                get: function() {
                    return total;
                }
            },
            position: {
                get: function() {
                    return position;
                },
                set: setPosition
            },
            duration: {
                get: function() {
                    return duration;
                }
            },
            loaded: {
                get: function() {
                    return loaded;
                }
            },
            loadedDuration:{
                get: function() {
                    return loadedDuration;
                }
            },
            ready: {
                get: function() {
                    return instances[slideIndex] && logoReady;
                }
            },
            etat: {
                get: function() {
                    return etat;
                },
                set: function(e) {
                    etat=e;
                }
            },
            loadAhead: {
                get: function() {
                    return loadAhead;
                },
                set: function(value) {
                    loadAhead = value;
                }
            },
            skipError: {
                get: function() {
                    return skipError;
                },
                set: function(value) {
                    skipError = value;
                }
            },
            haveAudio: {
                get: function() {
                    if (slide && slide.haveAudio) {
                        return true;
                    }
                    return false;
                }
            },
            videoDirectDisplay: {
                get: function() {
                    return videoDirectDisplay;
                },
                set: function(value) {
                    videoDirectDisplay = value;
                }
            }
        });

        this.dragging = false;
        this.vPlayer = null;

        /**
         * Obtient un slide
         * @param {int} index
         * @returns {Slide}
         */
        function getSlide(index) {
            var i = instances[index];
            if (i && i.show) {
                return i;
            }
        }

        function getPositionIndex(pos) {
            for (var i = 1; i < assets.length; i++) {
                var asset = assets[i];
                if (pos <= asset.start) {
                    return i-1;
                }
            }
            return assets.length-1;
        }

        function shouldSkipSlide(slide) {
            return (!slide || slide.error || !slide.show);
        }

        function getNextLoadedSlide(index) {
            var i = index;
            do {
                i = (i + 1) % total;
                var slide = getSlide(i);
                if (i === index) {
                    return -1;
                }
            } while (shouldSkipSlide(slide));
            return i;
        }

        /**
         * Change la position courante dans la timeline
         * @param {int} pos     position en milisecondes
         * @returns {undefined}
         */
        function setPosition(pos) {
            pos = Math.max(0, pos);
            var e = duration - 1;
            var seek = me.dragging;
            if (pos >= e) {
                pos = e;
                if (etat === PLAYING && !me.dragging) {
                    if ((opt.loop || defaultOpt.loop) == true) {
                        pos = 0;
                        loopCount++;
                        seek = true;//Force seek on loop
                    } else {
                        etat = COMPLETED;
                    }
                }
            } else if (etat === COMPLETED) {
                etat = PLAYING;
                loopCount++;
            }


            // Zone assets
            var pi = getPositionIndex(pos);
            var newSlide = getSlide(pi);
            if (skipError && shouldSkipSlide(newSlide)) {
                var to = getNextLoadedSlide(pi);
                if (to>=0) {
                    if (to < pi) {
                        loopCount++;                        
                    }
                    pi = to;
                    newSlide = getSlide(pi);
                    pos = newSlide.start;                    
                }
            }
            position = pos;

            if (pi !== slideIndex || !slide || slide !== newSlide) {

                if (slide) {
                    slide.hide();
                }

                slideIndex = pi;
                var ni = pi + 1;

                slide = newSlide;

                if (slide) {
                    slide.show(container);
                }
                container.addChild(transition);
                if (bmpLogo) {
                    container.addChild(bmpLogo);
                }
                loadNext(2);

                if (ni < assets.length && me.vPlayer) {//Précharger next video
                    var nextAsset = assets[ni];
                    if (nextAsset.type == "video") {
                        me.vPlayer.next = nextAsset.url;
                    }
                }
                seek = true;
            }
            updateTransitionAlpha();

            if (slide) {
                slide.timeline.setPosition(pos - slide.start);
                if (seek && slide.seek) {
                    slide.seek();
                }

            }
        }
        
        /**
         * Mise à jour du alpha de la transition en fondu
         * @returns {undefined}
         */
        function updateTransitionAlpha() {
            var alpha = 1;
            if (slide) {
                var slidePos = position - slide.start;
                var asset = assets[slideIndex];
                var slideDuration = asset.duration;
                var remain = slideDuration-slidePos;
                if (slidePos < FADE_DURATION) {
                    alpha = 1-slidePos/FADE_DURATION;
                } else if (remain < FADE_DURATION) {
                    alpha = 1-remain/FADE_DURATION;
                } else {
                    alpha = 0;
                }
            }
            alpha = Math.max(0, alpha);
            alpha = Math.min(1, alpha);
            transition.alpha = alpha;
        }

        /**
         * Attendre qu'un fichier soit chargé
         * @param {int} index   index de la asset
         * @param {func} after  function à appelé
         * @returns {undefined}
         */
        function whenImageReady(index, after) {
            if (instances[index]) {
                after();
            } else {
                ready.on(index, after, after, true);
            }
        }

        function updateFondGraphics() {
            if (fond) {
                var graphics = fond.graphics;
                graphics.clear();
                graphics.beginFill("#000000").drawRect(0, 0, stage.canvas.width,stage.canvas.height);
            }
        }
        
        function updateTransitionGraphics() {
            if (transition) {
                var graphics = transition.graphics;
                graphics.clear();
                graphics.beginFill("#000000").drawRect(0, 0, stage.canvas.width,stage.canvas.height);                
            }
        }

        function advanceLoaded() {
            var i = loaded;
            var d = loadedDuration;
            while (i < total) {
                if (!instances[i]) {
                    break;
                }
                d += assets[i].duration;
                i++;
            }
            loaded=i;
            loadedDuration = d;
        }

        function completed(index) {
            var event = new Event(index);
            ready.dispatchEvent(event);
            ready.removeAllEventListeners(index);
            advanceLoaded();
            loadNext();
        }

        function injectImage(index, img, asset) {
            var p;
            var text = data.text;
            switch (asset.type) {
                case "image":
                    p = new Photo(stage, img, ASSET_DELAY, FADE_DURATION);
                    break;
                case "intro":
                    p = new Introduction(stage, img, INTRO_DURATION, lang ? text[lang] : text, data.hommage);
                    break;
                case "conclu":
                    p = new Conclusion(stage, img, END_DURATION, lang ? text[lang] : text, data.hommage);
                    break;
                case "msg":
                    p = new Message(stage, img, asset.duration, asset.text[lang]);
                    break;
            }
            p.index = index;
            p.start = asset.start;
            instances[index] = p;
            completed(index);
        }

        function injectVideo(index, asset) {
            setTimeout(function() {
                var p = true;
                if (me.vPlayer) {
                    p = new Video(stage, me.vPlayer, asset);
                    p.index = index;
                    p.start = asset.start;
                    p.directDisplay = videoDirectDisplay
                }
                instances[index] = p;
                completed(index);                
            },1);
        }

        function injectError(index, asset) {
            if (instances[index]) {
                return;
            }
            var error = {
                fr: "Impossible de charger " + asset.url,
                en: "Cannot load " + asset.url,
                nl: "Kan afbeelding niet laden"
            }
            var hommage = data.hommage;
            var p = new Message(stage, imgLoader.items[hommage.introType] || nuageUrl, asset.duration, error[lang]);
            p.index = index;
            p.start = asset.start;
            p.error = true;
            instances[index] = p;
            completed(index);
        }


        function loadSlide(di) {
            var asset = assets[di];
            var type = asset.type;
            if (type != "video") {
                var idr = asset.idr;
                imgLoader.load(idr, asset.url, function (p, err) {
                    if (!assets[di] || !assetEquals(assets[di], asset)) {
                        //asset à été modifié sortie !
                        $g.warning("Annulation du chargement à cause de changement de contenu :", di, asset.url);
                        return;
                    }
                    if (p === Loader.COMPLETE) {
                        asset.error = null;
                        injectImage(di, imgLoader.items[idr].result, asset);
                    } else if (p === Loader.FAILED) {
                        asset.error = loopCount;
                        $g.warning("Échec du chargement de l'image :", di, asset.url, err);
                        injectError(di, asset);
                    }
                });
            } else {
                injectVideo(di, asset);
            }
        }

        /**
         * Pour garder le contrôle sur l'ordre de chargement
         * Charger un maximum de 2 assets en avances
         * @returns {undefined}
         */
        function loadNext(maxNbLoad) {
            if (imgLoader.nbLoad < (maxNbLoad||1)) {
                var di = Math.max(0, slideIndex-1);
                for (var i = 0; i < loadAhead; i++) {
                    if (di>=total) {
                        return;
                    }
                    if (!instances[di] || (assets[di].error && assets[di].error != loopCount)) {
                        loadSlide(di);
                        return;
                    }
                    di++;
                }
            }
        }
        
        function updateLogoPos() {
            if (bmpLogo) {
                var cwidth = stage.canvas.width;
                var cheight = stage.canvas.height;
                bmpLogo.x = cwidth - bmpLogo.width;            
                bmpLogo.y = cheight - bmpLogo.height;            
            }
        }
        
        var logoId = -1;
        /**
         * Chargement du logo si il y en a un
         * @returns {undefined}
         */
        function updateLogo() {
            var logo = data.logo;
            var newLogoId = data.logoId;
            if (logoId === newLogoId) {
                return;
            }
            logoId = newLogoId;
            if (bmpLogo) {
                bmpLogo.visible = false;
            }                
            if (logo) {
                imgLoader.load(newLogoId, logo, function (p) {
                    if (p === Loader.COMPLETE && logoId === newLogoId) {
                        tri(function() {
                            logoReady = true;
                            var img = imgLoader.items[newLogoId].result;
                            if (bmpLogo) {
                                bmpLogo.image = img;
                            } else {
                                bmpLogo = new Bitmap(img);
                            }
                            bmpLogo.visible = true;
                            bmpLogo.width = img.width;
                            bmpLogo.height = img.height;
                            bmpLogo.alpha = 0.75;
                            updateLogoPos();                                                                
                            loadNext();
                        });
                    } else if (p === Loader.FAILED) {
                        logoReady = true;
                        $g.warning("Échec du chargement du logo :", logo);
                        loadNext();
                    }
                });
            } else {
                logoReady=true;
            }
        }

        /**
         * Update stuff on resize
         * @returns {undefined}
         */
        me.resize = function() {
            updateFondGraphics();
            updateTransitionGraphics();
            if (slide) {
                slide.resize();
            }
            updateLogoPos();                                                
        };

        /**
         * Start the slideshow
         * @param {function} after  called when we are ready to start
         * @returns {undefined}
         */
        me.start = function(after) {
            etat=STARTING;
            fond = new Shape();
            fond.alpha=0;
            transition = new Shape();
            
            updateFondGraphics();
            updateTransitionGraphics();
            if (after) {
              Tween.get(fond, {ignoreGlobalPause: true})
              .to({alpha:1}, 1000, Ease.linear)
              .call(function() {
                  etat=PLAYING;
                  after();
              });
            } else {                
              fond.alpha = 1;
              etat=PLAYING;
            }
            container.addChild(fond);
        };

        me.replay = function() {
          if (etat===COMPLETED) {
              etat=PLAYING;
              position=0;
          }
        };

        me.advance = function(delta) {
            if (slide) {
                if (!slide.ready) {
                    slide.stillFrame();
                    return;
                }
            }
            setPosition(position + delta);
        };

        me.stillFrame = function() {
            if (slide && slide.stillFrame) {
                slide.stillFrame();
            }
        };

        function assetEquals(source, asset) {
            return (asset && asset.type == source.type && asset.idr === source.idr && asset.cmp === source.cmp);
        }

        function indexOf(source) {
            if (assets && source) {
                for (var i = 0; i < assets.length; i++) {
                    var asset = assets[i];
                    if (assetEquals(source, asset)) {
                        return i;
                    }
                }
            }
            return -1;
        };

        function setAssets(newAssets) {
            var newOrder = new Array(newAssets.length);
            var newInstances = new Array(newAssets.length);
            version++;
            var modified = 0;
            var inserted = 0;
            var unloaded = 0;
            
            duration = 0;
            for (var i = 0; i < newAssets.length; i++) {
                var source = newAssets[i];
                var index = indexOf(source);
                var asset = source;
                if (index >= 0) {
                    asset = assets[index];
                    var instance = instances[index];
                    if (instance) {
                        instance.version = version;
                        instance.start = asset.start;
                        instance.index = i;
                        newInstances[i] = instance;
                    } else {
                        unloaded++;
                    }
                    if (index !== i) {
                        modified++;                        
                    }
                } else {
                    inserted++;
                    modified++;
                    unloaded++;
                }
                newOrder[i] = asset;

                asset.start = duration;
                var d = asset.duration || ASSET_DELAY;
                asset.duration = d;
                if (!asset.idr) {
                    asset.idr=asset.url;
                }
                duration += d;
            }

            assets = newOrder;
            instances = newInstances;
            total = assets.length;
            if (modified>0) {
                loaded = 0;
                loadedDuration = 0;
                advanceLoaded();
            }
            //fix position
            if (etat === PLAYING || etat === PAUSED) {
                if (slide && slide.version === version) {
                    setPosition(slide.start + slide.timeline.position);
                } else {
                    //old slide no more in slideshow...
                    setPosition(0);
                }
            }
            return {
                modified: modified,
                inserted: inserted,
                unloaded: unloaded
            };
        };

        /**
         * Assigner les assets au slideshow
         * Peut être utiliser à la place de load
         * si on a la liste des assets
         * 
         * ATTENTION: Ne pas passer d'hommages vides où à un seul média, ça fait planter le système
         * 
         * @param {array} assets
         * @param {function} after  est appelé lorsque on est prèt
         * @param {string} newLang  language à utilisé
         * @returns {undefined}
         */
        me.setData = function (r, after, newLang) {
            //Ce code cause des incompatibilités
            /*if (!r.slides || r.slides.length <= 1) {
                //bail out of empty slideshow
                return;
            }*/
            var videos = [];
            if (etat === UNLOADED) {
                etat = UNSTARTED;
            }
            data = r;
            var hommage = r.hommage;
            nuageUrl = baseUrl + "img/slideshow/" + hommage.introType + "?v=2";
            var newAssets = r.slides.map(function (e) {
                var i = e.image;
                var v = e.video;
                var intro = e.intro;
                var ending = e.ending;
                var msg = e.msg;
                var bornYear = (hommage.born && hommage.born.year) ? hommage.born.year : "";
                var diedYear = (hommage.died && hommage.died.year) ? hommage.died.year : "";
                if (i) {
                    if (r.slides.length > 1) {
                        i.type = "image";
                    } else {
                        //Affichage spécial pour hommage à une seule image
                        i.type = "msg";
                        i.duration = 1000 * 60 * 60 * 60;
                        i.text = {
                            fr: "",
                            en: "",
                            nl: ""            
                        };
                    }
                    return i;
                } else if (v) {
                    v.type = "video";
                    videos.push(v);
                    return v;
                } else if (intro){
                    intro.type = "intro";
                    intro.url = nuageUrl;
                    intro.duration = INTRO_DURATION;
                    intro.cmp = (hommage.firstName||"") + " " + (hommage.lastName||"") +bornYear + " / " + diedYear;
                    return intro;
                } else if(ending){
                    ending.type = "conclu";
                    ending.url = nuageUrl;
                    ending.duration = END_DURATION;
                    ending.cmp = (hommage.firstName||"") + " " + (hommage.lastName||"") + bornYear + " / " + diedYear;
                    return ending;
                } else if (msg) {
                    msg.type = "msg";
                    msg.url = nuageUrl;
                    msg.cmp = msg.text[newLang];
                    return msg;
                } else {
                    return false;
                }
            });
            me.videos = videos;
            lang = newLang;
            var r = setAssets(newAssets);

            if (after) {
                whenImageReady(slideIndex, after);
            }
            loadNext();
            updateLogo();
            return r;
        };

        /**
         * Nettoyage du slideshow
         * @returns {undefined}
         */
        me.destroy = function() {
            instances=null;
            slide=null;
            //prevSlide=null;
        };

        /**
         * Chargement du slideshow
         * @param {string} url
         * @param {function} after when we have the list of asset, but we have not loaded the assets
         * @returns {undefined}
         */
        me.load = function(url, after) {
          etat=LOADING;
          server.call(url, {}, function(r) {
              me.setData(r, after);
          });
        };

    }

    Slideshow.STATES = STATES;

    $g.Slideshow = Slideshow;

})(PVPGEngine, createjs, jQuery);
